import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgWhatsApp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.18626 25.0058L4.18844 24.9996C4.49008 24.1395 4.79168 23.2794 5.08281 22.4088C0.0515537 13.6093 6.278 3.70313 14.7115 2.88025C22.674 2.10322 29.2025 7.82254 29.2223 15.628C29.243 23.864 21.2553 30.7799 12.2704 27.9689C12.0071 27.8865 11.7196 27.732 11.4201 27.5709C10.9486 27.3174 10.4475 27.048 9.96488 27.0196C9.18712 26.9738 8.23901 27.3541 7.35708 27.7079L7.3514 27.7102C6.98481 27.8572 6.62976 27.9995 6.30323 28.1045C5.99151 28.2048 5.69017 28.3052 5.39352 28.4039L5.38421 28.407C4.52273 28.6939 3.70032 28.9678 2.77734 29.1896C3.21814 27.7664 3.70233 26.3858 4.18626 25.0058ZM10.2361 24.5786C17.4918 28.9821 26.1798 24.043 26.9168 16.8486C27.5839 10.3357 22.3835 4.54065 15.3895 5.05009C7.40483 5.63154 2.60862 15.1627 7.52378 22.1375C7.08867 23.3299 6.68151 24.5501 6.30323 25.7992C6.86046 25.6378 7.39947 25.4583 7.93847 25.2787C8.688 25.029 9.43767 24.7793 10.2361 24.5786ZM13.0842 9.52551L13.1306 9.62247C13.8935 11.2161 14.9889 13.5044 13.0842 14.5433C14.0713 16.6302 15.7034 18.0721 17.8306 19.0187C18.2957 18.711 18.6558 18.2985 19.0158 17.8859C19.2035 17.6709 19.3912 17.4559 19.5937 17.2557C20.8285 17.7387 21.9827 18.3021 22.9839 19.0187C23.0869 21.3517 21.1209 22.2144 19.4581 22.1378C15.9499 21.9764 11.1284 17.5443 9.96505 14.2721C9.27469 12.3305 10.0687 8.61691 13.0842 9.52551Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgWhatsApp);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
